'use strict';

function MessageBanner() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [];
  this.$node = null;

  this.type = 'warning';
  this.title = null;
  this.msg = null;

  this.init = function () {
    this.$node = $(this.node);
    $.get('/member/components/message-banner', null, this._generateUI.bind(this));
  };

  this._generateUI = function (html) {
    this.$node.html(html);
    this.$node.find('div:first-child').addClass('message-banner--' + this.type);
    this.updateContent();
  };

  this.updateContent = function () {
    var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.title;
    var msg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.msg;

    if (title) {
      this.$node.find('.js--banner-title').text(title);
      this.$node.find('.js--banner-title').removeClass('hide');
    } else {
      this.$node.find('.js--banner-title').addClass('hide');
    }
    this.$node.find('.js--banner-message').text(msg);
  };

  this.show = function () {
    this.$node.show();
    this.$node[0].scrollIntoView(false);
  };

  this.hide = function () {
    this.$node.hide();
  };

  this.initAllReady = function () {};
}